import { render, staticRenderFns } from "./EditFlux.vue?vue&type=template&id=707862aa&scoped=true&"
import script from "./EditFlux.vue?vue&type=script&lang=ts&"
export * from "./EditFlux.vue?vue&type=script&lang=ts&"
import style0 from "./EditFlux.vue?vue&type=style&index=0&id=707862aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707862aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
